import * as React from 'react';
import { WGallery } from '../../core/gallery/WGallery';

interface DateiablageGalerieProps extends React.ClassAttributes<any> {
    data: any;
    id: string;
    name: string;
    modeIcon?: boolean;
    showTable?: boolean;
    onRoutingChange?: (routing: any) => void;
    routing?: any;
    showMode?: boolean;
    viewNotice?: JSX.Element;
    onChange?: (action: string, row: any) => void;
}

export class DateiablageGalerie extends React.Component<DateiablageGalerieProps> {

    constructor(props: any) {
        super(props);
        this.state = {};
    }

    render(): JSX.Element {
        return (
            <div style={{ paddingLeft: 0 }}>
                <WGallery
                    showMode={this.props.showMode}
                    title={this.props.name}
                    entity={this.props.id}
                    tid={9999}
                    view={this.props.showTable ? WGallery.VIEW_TABLE : WGallery.VIEW_ICONS}
                    viewNotice={this.props.viewNotice}
                    icon={this.props.modeIcon}
                    onChange={this.props.onChange}
                />
            </div>
        );
    }
}
